import React from 'react'
import Checkbox from 'app/theme/forms/Checkbox'
import LeadError from '../LeadError'

const mealTypes = [
  { value: 'breakfast', label: 'Breakfast' },
  { value: 'lunch', label: 'Lunch' },
  { value: 'dinner', label: 'Dinner' },
  { value: 'dessert', label: 'Dessert' },
]

const dishTypes = [
  { value: 'main', label: 'Main' },
  { value: 'side', label: 'Side' },
  { value: 'drink', label: 'Drink' },
  { value: 'dessert', label: 'Dessert' },
]

export default function LeadFoods(props) {
  const { data, setData, errors, setErrors } = props

  return (
    <div>
      <div className='px-4 py-3 font-light'>
        <h3 className='pl-3'>Select a meal:</h3>
        <div className='flex flex-wrap justify-between'>
          {mealTypes.map((type, index) => (
              <Checkbox
                key={index}
                label={type.label}
                className='p-3 w-32'
                data-test-id='meals'
                checked={data.meals.indexOf(type.value) >= 0}
                onChange={checked => {
                  setErrors({
                    ...errors,
                    meals: null,
                  })

                  const meals = checked
                    ? data.meals.concat(type.value)
                    : data.meals.filter(meal => meal !== type.value)

                  setData(prev => ({
                    ...prev,
                    meals,
                  }))
                }}
              />
            ))}
        </div>
        <LeadError message={errors?.meals || "_"} className={`${errors?.meals ? 'visible' : 'invisible'}`}/>
      </div>
      <div className='px-4 py-3 font-light'>
        <h3 className='pl-3'>Select the types of dishes:</h3>
        <div className='flex flex-wrap justify-between'>
          {dishTypes.map((type, index) => (
              <Checkbox
                key={index}
                label={type.label}
                className='p-3 w-32'
                data-test-id='foods'
                checked={data.foods.indexOf(type.value) >= 0}
                onChange={checked => {
                  setErrors({
                    ...errors,
                    foods: null,
                  })

                  const foods = checked
                    ? data.foods.concat(type.value)
                    : data.foods.filter(food => food !== type.value)

                  setData(prev => ({
                    ...prev,
                    foods,
                  }))
                }}
              />
          ))}
        </div>
        <LeadError message={errors?.foods || "_"} className={`${errors?.foods ? 'visible' : 'invisible'}`}/>
      </div>
    </div>
  )
}
